import "./add.css"
import { Form, Input, Button, Space } from "antd";
import { MinusCircleOutlined, PlusOutlined, ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';
const { TextArea } = Input;

function TableFormDoDont({ title, name }: { title: string, name: string }) {

    return (
        <>
            <div
                style={{ display: 'flex', justifyContent: 'center', fontWeight: 500, fontSize: 20, marginBottom: 8, marginTop: 16 }}>
                {title}
            </div>
            <div className="table-header-custom">
                <div className="table-header-item" style={{ width: '6%' }}> No. </div>
                <div className="table-header-item" style={{ width: '40%' }}> DO </div>
                <div className="table-header-item" style={{ width: '40%' }}> DON'T </div>
                <div className="table-header-item" style={{ width: '4%' }}>  </div>
            </div>
            
            <Form.List name={name}>
                {(fields, { add, remove, move }) => (
                    <div className="form-list-custom">
                        <div className="table-wrap-custom">
                            {fields.map(({ key, name, ...restField }, index) => (
                                <div key={key} className="row-c" >
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'order']}
                                        style={{ width: '60px', padding: 8, marginBottom: 0, textAlign: 'center' }}
                                    >
                                        {index + 1}
                                    </Form.Item>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'do']}
                                        style={{ flex: 1, marginBottom: 0, width: '100px'}}
                                    >
                                        <TextArea rows={4}></TextArea>
                                    </Form.Item>
                                   
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'dont']}
                                        style={{ flex: 1, marginBottom: 0, width: '100px'}}
                                    >
                                        <TextArea rows={4}></TextArea>
                                    </Form.Item>
                                        
                                    <Space direction="vertical" style={{ padding: 8 }}>
                                        {index != 0 && <ArrowUpOutlined onClick={() => move(index, index - 1)} />}
                                        <MinusCircleOutlined onClick={() => remove(name)} />
                                        {index != fields.length - 1 && <ArrowDownOutlined onClick={() => move(index, index + 1)} />}
                                    </Space>

                                    
                                </div>
                            ))}
                        </div>
                        <Form.Item>
                            <Button onClick={() => add()} block icon={<PlusOutlined />} style={{ marginTop: 16 }} type="primary" ghost>
                                Add Row
                            </Button>
                        </Form.Item>
                    </div>
                )}
            </Form.List>
        </>

    );
}

export default TableFormDoDont;